import { CampaignElementType } from 'scenes/common/types';
import { MotorFlowType } from 'scenes/motor/types';
import config, { FeatureToggleState } from 'shared/config';

export const campaignFlowMapping: {
  [key in CampaignElementType]: MotorFlowType[];
} = {
  [CampaignElementType.GetEstimate]: [
    MotorFlowType.QuoteDetails,
    MotorFlowType.AddDriver,
  ],
  [CampaignElementType.ExactQuote]: [MotorFlowType.CoverOptions],
  [CampaignElementType.PolicyDetails]: [
    MotorFlowType.PolicyDetails,
    MotorFlowType.AddPolicyHolder,
    MotorFlowType.ReviewDetails,
    MotorFlowType.ReviewDriver,
  ],
};

export const skipPromoPage =
  config.featureToggles.skipPromoPage === FeatureToggleState.ON;

export const suppressOfferApplied: boolean =
  config.featureToggles.campaign === FeatureToggleState.ON;

export const isCarCampaign = (quoteOrCampaignIdentifier: string) =>
  quoteOrCampaignIdentifier.length >= 4 &&
  quoteOrCampaignIdentifier.slice(0, 4) === 'COMO' &&
  suppressOfferApplied;
